import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import {selectIsPlateRecognitionEnabled} from 'stores/selectors/plateRecognitionSelectors';
import {HeaderLayout, LabelBar} from '../../components';

import withIntl from '../../lib/withIntl';

// FIXME: Reduce complexity to show buttons and handler
function PlateTypeEditorHeader({
  currentWizardView,
  isAllowedToNext,
  handleClickNext,
  handleClickCancel,
  handleClickBack,
  handleClickEjectTray,
  editModePlateProperties,
  isEjectedTray,
  intl,
  isEdit,
  isManualReteachPlate,
  disableEditSaveChanges,
  isError,
  onFinishReteachPlate,
  onCancelReteachPlate,
}) {
  const isPlateRecognitionEnabled = useSelector(selectIsPlateRecognitionEnabled);

  const buttonNextClickHandler = () => {
    if ((isEdit && currentWizardView === 2) || isManualReteachPlate) {
      onFinishReteachPlate();
      return;
    }
    handleClickNext();
  };

  const buttonCancelClickHandler = () => {
    if (isEdit && currentWizardView === 2) {
      onCancelReteachPlate();
      return;
    }
    handleClickCancel();
  };

  const getNextButtonText = () => {
    switch (currentWizardView) {
      // eslint-disable-next-line default-case-last
      default:
      case 1:
        return intl.formatMessage({id: 'plateTypeEditorContainer.header.nextButton'});
      case 2:
        if (isEdit) {
          return intl.formatMessage({id: 'plateTypeEditorContainer.header.finishButton'});
        }
        return intl.formatMessage({id: 'plateTypeEditorContainer.header.nextButton'});
      case 3:
        if (isEdit) {
          if (isPlateRecognitionEnabled) {
            return intl.formatMessage({id: 'plateTypeEditorContainer.header.UpdateEditButton'});
          }
          return intl.formatMessage({id: 'plateTypeEditorContainer.header.finishEditButton'});
        }
        if (!isPlateRecognitionEnabled) {
          return intl.formatMessage({id: 'plateTypeEditorContainer.header.finishButton'});
        }
        return intl.formatMessage({id: 'plateTypeEditorContainer.header.nextButton'});
      case 4:
        if (isEdit) {
          return intl.formatMessage({id: 'plateTypeEditorContainer.header.finishEditButton'});
        }
        return intl.formatMessage({id: 'plateTypeEditorContainer.header.finishButton'});
    }
  };

  const getCancelButtonText = () => {
    const lastStep = isPlateRecognitionEnabled ? 4 : 3;
    if (currentWizardView === lastStep && isEdit) {
      return intl.formatMessage({id: 'plateTypeEditorContainer.header.cancelEditButton'});
    }
    return intl.formatMessage({id: 'plateTypeEditorContainer.header.cancelButton'});
  };

  return (
    <HeaderLayout className="header">
      <HeaderLayout.Left>
        <div className="menu-n-title">
          <LabelBar text={isEdit ? 'Plate Editor' : 'Plate Type Creator'} className="title" />
        </div>
      </HeaderLayout.Left>
      <HeaderLayout.Right>
        {isManualReteachPlate && (
          <Button
            bsStyle="warning"
            type="button"
            className={`header-button common-button ${editModePlateProperties ? 'disabled' : ''}`}
            onClick={() => handleClickBack()}
            disabled={editModePlateProperties}
          >
            {intl.formatMessage({id: 'plateTypeEditorContainer.header.backButton'})}
          </Button>
        )}
        {/* eslint-disable-next-line no-nested-ternary */}
        {currentWizardView === 1 ? (
          <Button
            bsStyle="warning"
            type="button"
            className={`header-button eject-tray-button ${isEjectedTray ? 'disabled' : ''}`}
            disabled={isEjectedTray || isEdit}
            onClick={() => {
              handleClickEjectTray();
            }}
          >
            {intl.formatMessage({id: 'plateTypeEditorContainer.header.ejectTrayButton'})}
          </Button>
        ) : !isEdit ? (
          <Button
            bsStyle="warning"
            type="button"
            className={`header-button common-button ${editModePlateProperties ? 'disabled' : ''}`}
            onClick={() => handleClickBack()}
            disabled={editModePlateProperties}
          >
            {intl.formatMessage({id: 'plateTypeEditorContainer.header.backButton'})}
          </Button>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <></>
        )}
        <Button
          bsStyle="warning"
          type="button"
          className={`header-button common-button ${(!isAllowedToNext || editModePlateProperties) && 'disabled'}`}
          onClick={buttonNextClickHandler}
          disabled={!isAllowedToNext || editModePlateProperties || (isEdit && disableEditSaveChanges) || isError}
        >
          {getNextButtonText()}
        </Button>
        <Button className="header-button cancel-button" onClick={buttonCancelClickHandler}>
          <span>{getCancelButtonText()}</span>
        </Button>
      </HeaderLayout.Right>
    </HeaderLayout>
  );
}

PlateTypeEditorHeader.propTypes = {
  currentWizardView: PropTypes.number.isRequired,
  isAllowedToNext: PropTypes.bool.isRequired,
  handleClickNext: PropTypes.func.isRequired,
  handleClickCancel: PropTypes.func.isRequired,
  handleClickBack: PropTypes.func.isRequired,
  handleClickEjectTray: PropTypes.func.isRequired,
  editModePlateProperties: PropTypes.bool,
  isEjectedTray: PropTypes.bool,
  intl: PropTypes.any.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isManualReteachPlate: PropTypes.bool,
  disableEditSaveChanges: PropTypes.bool.isRequired,
  isError: PropTypes.any.isRequired,
  onFinishReteachPlate: PropTypes.func,
  onCancelReteachPlate: PropTypes.func,
};

PlateTypeEditorHeader.defaultProps = {
  isManualReteachPlate: false,
  editModePlateProperties: false,
  isEjectedTray: false,
  onFinishReteachPlate: () => {},
  onCancelReteachPlate: () => {},
};

export default withIntl(PlateTypeEditorHeader);
